module.exports = __webpack_public_path__ + "img/13.c9404503.jpg";